// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"src-domains-auth-components-styles__wrapper--3HSF-","blink":"src-domains-auth-components-styles__blink--3TDSq"};